import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';

// Import Quill styles
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";


Vue.use(VueQuillEditor);
